import React from "react";

import {
  Grid,
  TextField,
  Button,
  MenuItem,
} from "@mui/material";

const statusOptions = [
  "",
  "Available",
  "Assigned",
  "Allocated",
  "Activated",
  "Suspended",
  "Deleted",
];

const InventoryFilter = ({
  search,
  setSearch,
  providerStatus,
  setProviderStatus,
  onSearch,
  onReset,
  onDelete,
  selectedCount,
}) => {

  return (
    <Grid
      container
      spacing={2}
      alignItems="center"
    >
      <Grid item xs={12} md={5}>

        <TextField
          fullWidth
          placeholder="Search UID / IMEI / ICCID / MSISDN / Basket"
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
        />

      </Grid>

      <Grid item xs={12} md={3}>

        <TextField
          select
          fullWidth
          label="Provider Status"
          value={providerStatus}
          onChange={(e) =>
            setProviderStatus(e.target.value)
          }
        >

          {statusOptions.map((status) => (
            <MenuItem
              key={status}
              value={status}
            >
              {status || "Any"}
            </MenuItem>
          ))}

        </TextField>

      </Grid>

      <Grid item>

        <Button
          variant="contained"
          onClick={onSearch}
        >
          Search
        </Button>

      </Grid>

      <Grid item>

        <Button
          variant="outlined"
          onClick={onReset}
        >
          Reset
        </Button>

      </Grid>

      <Grid item>

        <Button
          color="error"
          variant="outlined"
          disabled={!selectedCount}
          onClick={onDelete}
        >
          Delete Selected
          {selectedCount > 0 &&
            ` (${selectedCount})`}
        </Button>

      </Grid>
    </Grid>
  );
};

export default InventoryFilter;